export default "__VITE_ASSET__150324df__"